import { combineReducers } from 'redux'
import TrackerManagementTrackerListSlice from '../../../slices/experiences/TrackerManagementTrackerListSlice'
import TrackerManagementTrackerListExportSlice from '../../../slices/experiences/TrackerManagementTrackerListExportSlice'
import TrackerManagementTrackerPositionsSlice from '../../../slices/experiences/TrackerManagementTrackerPositionsSlice'
import TrackerManagementTrackerPositionsExportSlice from '../../../slices/experiences/TrackerManagementTrackerPositionsExportSlice'
import TrackerManagementTrackerActivityLogsSlice from '../../../slices/experiences/TrackerManagementTrackerActivityLogsSlice'

const TrackerManagementExperienceStore = combineReducers({
  list: TrackerManagementTrackerListSlice.reducer,
  listExport: TrackerManagementTrackerListExportSlice.reducer,
  trackerPositions: TrackerManagementTrackerPositionsSlice.reducer,
  trackerPositionsExport: TrackerManagementTrackerPositionsExportSlice.reducer,
  activityLogs: TrackerManagementTrackerActivityLogsSlice.reducer
})

export default TrackerManagementExperienceStore

